import React from "react";
import PropTypes from "prop-types";
import cs from "classnames";

import { Image } from "@lululemon/ui-library";

import styles from "./story-block-text.module.scss";

function StoryBlockText({ description, scaleImage, title, titleId }) {
  return (
    <div className={styles.wrapper}>
      {title && (
        <h4 className={styles.title} id={titleId || undefined}>
          {title}
        </h4>
      )}
      {description && (
        <p className={cs("lll-text-body-2", styles.description)}>
          {description}
        </p>
      )}
      {scaleImage?.fields && (
        <Image
          className={styles.scaleImage}
          alt={scaleImage.fields.description}
          src={scaleImage.fields.imageUrl}
          mobileSrc={scaleImage.fields.mobileImageUrl}
        />
      )}
    </div>
  );
}

StoryBlockText.propTypes = {
  description: PropTypes.string,
  scaleImage: PropTypes.shape({
    fields: PropTypes.shape({
      description: PropTypes.string,
      imageUrl: PropTypes.string,
      mobileImageUrl: PropTypes.string
    })
  }),
  title: PropTypes.string
};

StoryBlockText.defaultProps = {
  description: "",
  scaleImage: null,
  title: ""
};

export default StoryBlockText;
